import {useHistory} from "react-router-dom";
import {onError} from "../lib/errorLib";
import {API} from "aws-amplify";
import HqsForm, {initialValues} from "../components/forms/HqsForm";

export default function NewHqs() {
    //const file = useRef(null);
    const history = useHistory();

    const handleSubmit = async (values) => {
        try {
            //const attachment = file.current ? await s3Upload(file.current) : null;
            //await createHqs({content, attachment});
            await createHqs({content: values, attachment: null});
            history.push("/");
        } catch (e) {
            onError(e);
        }
    }

    const createHqs = (note) => {
        return API.post("hqs", "/hqs", {
            body: note
        });
    }



    return HqsForm(initialValues(), handleSubmit);
}
